<template>
  <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="3.7874" cy="7.88603" r="1.17021" fill="currentColor" />
    <circle cx="7.26006" cy="7.88603" r="1.17021" fill="currentColor" />
    <rect x="0.623438" y="1.1" width="9.8" height="9.8" rx="1.70262" stroke="currentColor" stroke-width="1.2" />
  </svg>
</template>
